/// <reference path="./types.d.ts" />
import { AiMotuEngine } from './dist/ai-motu-sdk.es.js'
import './dist/dist-sdk.css'
import { saveTemplate, uploadfile, loadTemplate, onDpiChange, setfontList, uploadFont, AIsearchimg, downloadFile } from '../common/design'
import material from '../components/leftPanel/material/material.vue'
import image from '../components/leftPanel/image/image.vue'
import template from '../components/leftPanel/template/template.vue'
import text from '../components/text.vue'
import user from '../components/leftPanel/user/user.vue'
import team from '../components/leftPanel/team/team.vue'
// @ts-ignore
import login from '../components/topPanel/login/login.vue'
import createDesing from '../components/fileActions/createDesign/createDesing.vue'
import fileImport from '../components/fileActions/fileImport/fileImport.vue'
import JSONImport from '../components/fileActions/jsonimport/JSONImport.vue'
import resourceLibrary from '../components/resourceLibrary/resourceLibrary.vue'
/**
 * 初始化 SDK 实例
 * @param container 容器选择器
 * @returns SDK 实例
 */
export const initSdk = async (container: string = '#page', islogin: boolean = false) => {
  return new AiMotuEngine({
    container,
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,  // 加载模板
      uploadfile: uploadfile,      // 上传文件
      saveTemplate: saveTemplate,  // 保存模板
      downloadFile: downloadFile,  // 下载文件
    },
    dynamicDpi: true,
    fontconfig: {
      showFontUplaod: false,
      fontUpload: async (uploadList: any) => {
        await uploadFont(uploadList)
      },
    },
    showDownloadFile: islogin,
    leftPanel: [ // 自定义左侧导航栏
      { name: '模板', icon: 'moban', component: template },
      { name: '素材', icon: 'sucai', component: material },
      { name: '图片', icon: 'tupian', component: image },
      { name: '我的', icon: 'wode', component: user },
      // { name: '团队', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/7_1763971495000_7575a4b4-7e59-470f-912e-1c6ce8f08ff3.png', component: team },
    ],
    headerPanel: [
      { position: 'RightFront', component: login },
    ],
    canvasContextMenu: [
      // { position: 13, element: true, item: { text: '打标', handler: () => { opentagdialog() } } },
    ],
    fileActions: [
      { component: createDesing },
      { component: fileImport },
      { component: JSONImport },
    ],
    toolbarActions: [
      {
        position: 3, element: {
          tooltip: 'AI搜图',
          icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/4_1763694135316_扫码.png',
          iconClassName: 'text-18px color-#333',
          btnClass: 'h-[32px] w-[32px] rounded-3px mr-4px',
          type: 'Image',
          onClick: AIsearchimg
        }
      },
    ],
    resourceLibrary: {
      component: resourceLibrary,
    }
  })
}


export interface SdkConfig {
  container?: string
  onDpiChange?: (dpi: number) => void
  hostMethods?: {
    loadTemplate?: Function
    uploadfile?: Function
    saveTemplate?: Function
  }
  fontconfig?: {
    showFontUplaod?: boolean
    fontUpload?: Function
    fontList?: Array<any>
  }
  dynamicDpi?: boolean
  showDownloadFile?: boolean
  leftPanel?: Array<any>,
  canvasContextMenu?: Array<any>,
}
// getDynamicDpi: true,
/**
 * 使用自定义配置初始化 SDK
 * @param config SDK 配置选项
 * @returns SDK 实例
 */
export const initSdkWithConfig = (config: SdkConfig) => {
  const defaultConfig: SdkConfig = {
    container: '#page',
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,
      uploadfile: uploadfile,
      saveTemplate: saveTemplate,
    },
    dynamicDpi: true,
    showDownloadFile: true,
    leftPanel: [
      { name: '素材', icon: 'sucai', component: material },
      { name: '图片', icon: 'tupian', component: image },
      { name: '模板', icon: 'moban', component: template },
      { name: '文字', icon: 'tupianbianjiqi_wenzi', component: text },
      { name: '我的', icon: 'wode', component: user },

    ],



  }

  // 合并配置
  const mergedConfig = { ...defaultConfig, ...config }

  return new AiMotuEngine(mergedConfig)
}

// 导出字体列表供外部使用
